export const MobileNavMenuItem = ({ title, onClick }: { title: string; onClick: () => void }) => {
    return (
        <button onClick={onClick} className="w-full text-black dark:text-white px-8 py-4 text-left">
            {title}
        </button>
    );
};
